'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = tooltipNotification;
/**
 * Tooltip notification for onclick. Click a button & display a tooltip above
 * the button or another nearby element.
 */
function tooltipNotification() {

  // Gets all activator buttons. (Use Array.prototype.slice.call() to make it compatible with IE11)
  var tooltipActivators = Array.prototype.slice.call(document.querySelectorAll('.tooltip-notification__button'));

  // Loops through the buttons...
  Array.prototype.forEach.call(tooltipActivators, function (object) {

    // ... and adds an onclick event to each.
    object.onclick = function (event) {

      // Find the corresponding display element - both the button and the
      // display should be wrapped in '.tooltip-notification'. This allows us
      // to add notifications in multiple areas of the page without worry that
      // we will activate the tooltip somewhere else.
      var notificationObject = event.target.closest('.tooltip-notification').querySelector('.tooltip-notification__display');

      // This class adds an opaque backround of '0.9'(originally the opacity
      // is 0).
      var classNameToAdd = 'tooltip-notification__display--notify';
      notificationObject.classList.add(classNameToAdd);

      // Remove the class after 3 seconds.
      setTimeout(function () {
        notificationObject.classList.remove(classNameToAdd);
      }, 3000);
    };
  });
}